import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTriangleUpSmall: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-triangle-up-small, dropdown, caret"><path d="M15.25 13H8.75L12 9L15.25 13Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconChevronTriangleUpSmall;
